import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ContactCTA = () => {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-slate-900 rounded-[3rem] p-12 md:p-24 text-center relative overflow-hidden shadow-2xl"
        >
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/20 blur-[100px] -mr-20 -mt-20" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/10 blur-[100px] -ml-20 -mb-20" />
          <div className="relative z-10">
            <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-8">Ready to Grow Your Business?</h2>
            <p className="text-xl text-slate-400 mb-12 max-w-2xl mx-auto font-medium">
              We help businesses build digital systems that create long-term growth. Connect with us on WhatsApp to start your project.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a 
                href="https://go.digitalgigs.eu/chat" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-12 py-5 text-xl font-bold rounded-full text-slate-900 bg-emerald-400 hover:bg-emerald-300 transition-all shadow-xl shadow-emerald-400/20 w-full sm:w-auto"
              >
                Get a Free Quote
                <SafeIcon icon={FiArrowRight} className="ml-3" />
              </a>
              <a 
                href="https://go.digitalgigs.eu/chat" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-12 py-5 text-xl font-bold rounded-full text-white border border-white/20 hover:bg-white/10 transition-all w-full sm:w-auto"
              >
                Chat with Us
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactCTA;
